<template>
  <section v-if="displayableSuggestedItemSkus" class="suggested-item-sku">
    <div class="suggested-item-sku__top-gray-border" />
    <div class="suggested-item-sku__container">
      <div class="suggested-item-sku__head">
        <h2 class="suggested-item-sku__title">おすすめの組み合わせギフト</h2>
      </div>
      <div class="special-feature__lead">
        <div v-if="isLoading" class="suggested-item-sku__loading">
          <Loading />
        </div>
        <div v-else class="suggested-item-sku__items">
          <div class="suggested-item-sku__horizontal-scroll">
            <HorizontalScroll
              ref="suggested-item-sku-horizontal"
              ref-name="suggested-item-sku"
            >
              <ItemSkuBoxes
                :item-skus="suggestedItemSkus"
                :scrollable="false"
                @mount="onMountItemSkuBoxes"
                @clicked-add-button="clickAddButton"
                @clicked-link="clickLink"
              />
            </HorizontalScroll>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import ItemSkuBoxes from '../../molecules/item_boxes/ItemSkuBoxes.vue'
import Loading from '../../atoms/loadings/Loading.vue'
import axios from 'axios'
import qs from 'qs'
import HorizontalScroll from '../../molecules/horizontal-scrolls/HorizontalScroll.vue'
export default {
  components: { ItemSkuBoxes, Loading, HorizontalScroll },
  props: {
    itemSkuIds: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      suggestedItemSkus: [],
      isLoading: false
    }
  },
  computed: {
    displayableSuggestedItemSkus() {
      return !this.isLoading && this.suggestedItemSkus.length !== 0
    }
  },
  watch: {
    itemSkuIds: {
      handler() {
        this.getSuggestedItemSkus()
      },
      deep: true
    }
  },
  methods: {
    async getSuggestedItemSkus() {
      this.isLoading = true
      try {
        const res = await axios.get(
          '/api/v1/pickup/item_sku_suggestions/suggested_item_skus',
          {
            params: { item_sku_ids: this.itemSkuIds },
            paramsSerializer: params => {
              return qs.stringify(params, { arrayFormat: 'brackets' })
            }
          }
        )
        this.suggestedItemSkus = res.data.data
          .map(itemSkus => itemSkus.attributes)
          .filter(
            // すでにギフトカードに追加されている商品はおすすめから除く。
            itemSku =>
              !this.itemSkuIds.some(itemSkuIds => itemSkuIds === itemSku.id),
            this
          )
          .map(itemSku => ({
            id: itemSku.id,
            linkUrl: `/items/${itemSku.itemId}/item_skus/${itemSku.id}`,
            imageUrl: itemSku.imageUrl,
            brandName: itemSku.brandName,
            itemId: itemSku.itemId,
            itemName: itemSku.itemName,
            itemSkuName: itemSku.name,
            itemSkuPrice: itemSku.price.toLocaleString(),
            isIncludingTax: itemSku.isIncludedTax,
            hasMultipleItemSkus: itemSku.hasMultipleItemSkus,
            soldOut: itemSku.outOfStock,
            labels: itemSku.labels || []
          }))
        this.fisherYatesShuffle(this.suggestedItemSkus)
      } catch (error) {
        const errorMessage =
          error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : '情報の取得に失敗しました。しばらく経ってから再度アクセスしてください'
        this.$emit('error', errorMessage)
      }
      this.isLoading = false
    },
    fisherYatesShuffle(array) {
      for (var i = array.length - 1; i > 0; i--) {
        const r = Math.floor(Math.random() * (i + 1))
        const tmp = array[i]
        array[i] = array[r]
        array[r] = tmp
      }
    },
    onMountItemSkuBoxes() {
      this.$refs['suggested-item-sku-horizontal'].initializeValues()
    },
    async clickAddButton(itemId, itemSkuId) {
      dataLayer.push({
        event: 'add_to_cart',
        item_sku_id: itemSkuId,
        ecommerce: {
          items: [
            {
              item_id: itemSkuId,
              quantity: 1,
              item_list_name: 'suggestion list'
            }
          ]
        }
      })
      this.$emit('clicked-suggested-item-sku-add-button', itemId, itemSkuId)
      event.preventDefault()
    },
    clickLink(itemSkuId) {
      dataLayer.push({
        event: 'select_item',
        ecommerce: {
          items: [
            {
              item_id: itemSkuId,
              item_list_name: 'suggestion list'
            }
          ]
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.suggested-item-sku {
  &__top-gray-border {
    height: 16px;
    background-color: $gray-2;

    @media all and (min-width: $base-contents-width) {
      display: none;
    }
  }

  &__container {
    max-width: 1040px;
    margin: 0 auto;

    @media all and (max-width: ($base-contents-width - 1)) {
      margin: 0;
    }
  }

  &__title {
    @extend %subhead-bold;
    text-align: left;
    margin: 0 24px;

    @media all and (max-width: ($base-contents-width - 1)) {
      margin: 24px 16px;
    }
  }

  &__items {
    margin: 24px;

    @media all and (max-width: ($base-contents-width - 1)) {
      margin: 0 0 24px 16px;
    }
  }
}
</style>
